import React from 'react';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import TimePickerField from './TimePickerField'; // Asegúrate de que la ruta sea correcta

// Checkbox con TimePicker para must start/finish working
const CheckboxTimePicker = React.memo(({
    checkboxLabel,
    timeLabel,
    checked,
    onCheckboxChange,
    timeValue,
    onTimeChange,
    gridSizes = { checkbox: 9, time: 3 }
}) => (
    <Grid container sx={{ mt: 2 }}>
        <Grid size={{ xs: gridSizes.checkbox, sm: gridSizes.checkbox, md: gridSizes.checkbox, lg: gridSizes.checkbox, xl: gridSizes.checkbox }}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={onCheckboxChange}
                    />
                }
                label={checkboxLabel}
            />
        </Grid>
        <Grid size={{ xs: gridSizes.time, sm: gridSizes.time, md: gridSizes.time, lg: gridSizes.time, xl: gridSizes.time }}>
            <TimePickerField
                id={`time-${checkboxLabel.replace(/\s+/g, '-').toLowerCase()}`}
                label={timeLabel}
                value={timeValue}
                onChange={onTimeChange}
                disabled={!checked}
            />
        </Grid>
    </Grid>
));

export default CheckboxTimePicker;
CheckboxTimePicker.displayName = 'CheckboxTimePicker';